import { t_dataName } from 'src/app/services/apiHandler/basicMachineFunctions/basic-machine-functions.service';

export type t_EquipmentCurrentsDataPoint = {
    generalName: string;
    dataName: t_dataName;
    unit: string;
    value?: number;
    position: e_Positions;
};

export type t_EquipmentCurrentsDataset = {
    dataPoints: t_EquipmentCurrentsDataPoint[];
};

export enum e_Positions {
    Connection_Upper_Undercarriage,
    Undercarriage,
    Engine_Uppercarriage,
    Boom_Cylinder,
    Stick_Cylinder,
    Tool,
}

export var initEquipmentCurrentDataset: t_EquipmentCurrentsDataset = {
    dataPoints: [
        {
            generalName: 'DATANAMES.CURRENT.OUTRIGGER_HOIST',
            dataName: {
                name: 'OutriggerHoistCurrent',
            },
            unit: 'mA',
            position: e_Positions.Connection_Upper_Undercarriage,
        },
        {
            generalName: 'DATANAMES.CURRENT.OUTRIGGER_LOWER',
            dataName: {
                name: 'OutriggerLowerCurrent',
            },
            unit: 'mA',
            position: e_Positions.Connection_Upper_Undercarriage,
        },
        {
            generalName: 'DATANAMES.CURRENT.SLEW_LEFT',
            dataName: {
                name: 'SlewLeftCurrent',
            },
            unit: 'mA',
            position: e_Positions.Connection_Upper_Undercarriage,
        },
        {
            generalName: 'DATANAMES.CURRENT.SLEW_RIGHT',
            dataName: {
                name: 'SlewRightCurrent',
            },
            unit: 'mA',
            position: e_Positions.Connection_Upper_Undercarriage,
        },
        {
            generalName: 'DATANAMES.CURRENT.BOOM_SUM',
            dataName: {
                name: 'ValveBoomSum',
            },
            unit: 'mA',
            position: e_Positions.Boom_Cylinder,
        },
        {
            generalName: 'DATANAMES.CURRENT.BOOM_HOIST',
            dataName: {
                name: 'BoomHoistCurrent',
            },
            unit: 'mA',
            position: e_Positions.Boom_Cylinder,
        },
        {
            generalName: 'DATANAMES.CURRENT.BOOM_LOWER',
            dataName: {
                name: 'BoomLowerCurrent',
            },
            unit: 'mA',
            position: e_Positions.Boom_Cylinder,
        },
        {
            generalName: 'DATANAMES.CURRENT.BOOM_LOWER_PF',
            dataName: {
                name: 'BoomPipeFractureCurrent',
            },
            unit: 'mA',
            position: e_Positions.Boom_Cylinder,
        },
        {
            generalName: 'DATANAMES.CURRENT.STICK_SUM',
            dataName: {
                name: 'ValveStickSum',
            },
            unit: 'mA',
            position: e_Positions.Stick_Cylinder,
        },
        {
            generalName: 'DATANAMES.CURRENT.STICK_EXTEND',
            dataName: {
                name: 'StickExtendCurrent',
            },
            unit: 'mA',
            position: e_Positions.Stick_Cylinder,
        },
        {
            generalName: 'DATANAMES.CURRENT.STICK_RETRACT',
            dataName: {
                name: 'StickRetractCurrent',
            },
            unit: 'mA',
            position: e_Positions.Stick_Cylinder,
        },
        {
            generalName: 'DATANAMES.CURRENT.STICK_RETRACT_PF',
            dataName: {
                name: 'StickRetractPipefracture',
            },
            unit: 'mA',
            position: e_Positions.Stick_Cylinder,
        },
        {
            generalName: 'DATANAMES.CURRENT.FAN',
            dataName: {
                name: 'FanCurrent',
            },
            unit: 'mA',
            position: e_Positions.Engine_Uppercarriage,
        },
        {
            generalName: 'DATANAMES.CURRENT.CABINE_HOIST',
            dataName: {
                name: 'CabineHoistCurrent',
            },
            unit: 'mA',
            position: e_Positions.Engine_Uppercarriage,
        },
        {
            generalName: 'DATANAMES.CURRENT.CABINE_LOWER',
            dataName: {
                name: 'CabineLowerCurrent',
            },
            unit: 'mA',
            position: e_Positions.Engine_Uppercarriage,
        },
        {
            generalName: 'DATANAMES.CURRENT.TOOL_OPEN',
            dataName: {
                name: 'ToolOpenCurrent',
            },
            unit: 'mA',
            position: e_Positions.Tool,
        },
        {
            generalName: 'DATANAMES.CURRENT.TOOL_CLOSE',
            dataName: {
                name: 'ToolCloseCurrent',
            },
            unit: 'mA',
            position: e_Positions.Tool,
        },
        {
            generalName: 'DATANAMES.CURRENT.TOOL_SLEW_LEFT',
            dataName: {
                name: 'ToolSlewLeftCurrent',
            },
            unit: 'mA',
            position: e_Positions.Tool,
        },
        {
            generalName: 'DATANAMES.CURRENT.TOOL_SLEW_RIGHT',
            dataName: {
                name: 'ToolSlewRightCurrent',
            },
            unit: 'mA',
            position: e_Positions.Tool,
        },
        {
            generalName: 'DATANAMES.CURRENT.DRIVE_FORWARD',
            dataName: {
                name: 'DriveForwardCurrent',
            },
            unit: 'mA',
            position: e_Positions.Undercarriage,
        },
        {
            generalName: 'DATANAMES.CURRENT.DRIVE_BACKWARD',
            dataName: {
                name: 'DriveBackwardCurrent',
            },
            unit: 'mA',
            position: e_Positions.Undercarriage,
        },
        {
            generalName: 'DATANAMES.CURRENT.STEERING_LEFT',
            dataName: {
                name: 'SteeringLeftCurrent',
            },
            unit: 'mA',
            position: e_Positions.Undercarriage,
        },
        {
            generalName: 'DATANAMES.CURRENT.STERING_RIGHT',
            dataName: {
                name: 'SteeringRightCurrent',
            },
            unit: 'mA',
            position: e_Positions.Undercarriage,
        },
    ],
};
